import { render, staticRenderFns } from "./AromaMine.vue?vue&type=template&id=19313451&scoped=true"
import script from "./AromaMine.vue?vue&type=script&lang=js"
export * from "./AromaMine.vue?vue&type=script&lang=js"
import style0 from "./AromaMine.vue?vue&type=style&index=0&id=19313451&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19313451",
  null
  
)

export default component.exports